export default {
  items: [
    {
      title: true,
      name: 'Меню',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    {
      name: 'Публикации',
      icon: 'icon-note',
      children: [
        {
          name: 'Авторы',
          url: '/authors',
          icon: 'icon-people'
        },
        {
          name: 'Темы',
          url: '/themes',
          icon: 'icon-list'
        },
        {
          name: 'Публикации',
          url: '/publications',
          icon: 'icon-note'
        }
      ]
    }
  ]
}
